export default __webpack_public_path__ + "static/media/151-roof.c29da57e.png";